import { NavLink } from "react-router-dom";

export default function CustomNavLink(props) {
  return <NavLink {...props} activeclassname="active" />;
}
